import { GetStaticPropsContext, GetStaticPropsResult, NextPage } from "next";
import { useEffect } from "react";

import PageHead, { TwitterCard } from "~/components/common/PageHead";
import QuestDetailPage from "~/components/quest/page/[id]/QuestDetailPage";
import { Props } from "~/components/quest/page/[id]/lib";
import { Layout } from "~/lib/client/layout";
import { PageName } from "~/lib/client/logger/base";
import { useActivityLogger } from "~/lib/client/logger/useActivityLogger";
import { createGraphqlClient } from "~/lib/graphql/graphqlClient";

export async function getStaticPaths() {
  const client = createGraphqlClient();
  const { quests } = await client.questIndexContent();
  return {
    paths: quests.map((item) => ({ params: { id: item.id.toString() } })),
    fallback: "blocking",
  };
}

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<Props>> {
  const questId = context.params?.id;
  if (typeof questId !== "string") {
    return {
      notFound: true,
    };
  }

  const client = createGraphqlClient();
  const { quest } = await client.questDetailContent({ id: Number(questId) });
  return {
    props: { quest },
  };
}

const pageName: PageName = "questDetail";

const Page: NextPage<Props> = (props) => {
  const logger = useActivityLogger();

  const twitterCardParams = new URLSearchParams({
    title: props.quest.title,
    fave_name: props.quest.category.name,
  }).toString();

  const twitterCard: TwitterCard = {
    cardType: "summary_large_image",
    creator: props.quest.user.name,
    ogImage: `https://www.fussy.fun/api/og/quest?${twitterCardParams}`,
  };

  const headProps = {
    title: `${props.quest.title} | FUSSY`,
    twitterCard,
    ogDescription: "クエストを見つけて推しを応援しよう！",
  };

  useEffect(() => {
    if (logger === undefined) return;

    (async () => {
      await logger({
        pageName,
        actionName: "show",
      });
    })();
  }, [logger]);

  return (
    <>
      <PageHead {...headProps} />
      <Layout layoutType={"YTLayout"}>
        <QuestDetailPage {...props} />
      </Layout>
    </>
  );
};

export default Page;
